export default "__VITE_ASSET__3fe31ddf__"